import axios from "axios";



export const getPayments = async (dealerId) => {
  const response = await axios.get(
     `https://alcobrakeadmin.com/v3/us/fullclients/fetchautopayments?dealerId=${dealerId}`
  );

  console.log("API DATA 👉", response.data); // DEBUG

  return Array.isArray(response.data?.data) ? response.data.data : [];
};
export const getInvoices = async (customerId) => {
  console.log("========== API CALL ==========");
  console.log("SENDING cust_id 👉", customerId);

  const res = await axios.get(
    `https://alcobrakeadmin.com/v3/v2/stripepayments/getcustomerinvoices?cust_id=${customerId}`
  );

  console.log("API FULL RESPONSE 👉", res.data);
  console.log("API COUNT 👉", res.data?.count);
  console.log("API DATA 👉", res.data?.data);

  const invoices = res.data?.invoices || res.data?.data;
  return Array.isArray(invoices) ? invoices : [];
};

export const cancelInvoiceAPI = async (invoiceId) => {
  return await axios.get(
    "https://alcobrakeadmin.com/v3/v2/stripepayments/cancelintinvoice",
    {
      params: { invoiceid: invoiceId },
    }
  );
};

// ✅ Cash Pay
export const cashPayAPI = async (payload) => {
  return await axios.post(
    "https://alcobrakeadmin.com/v3/v2/stripepayments/reccacashpayment",
    payload
  );
};
